/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Status_ClosedInputs */

const en_reports_status_closed = /** @type {(inputs: Reports_Status_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed`)
};

const pt_br2_reports_status_closed = /** @type {(inputs: Reports_Status_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encerrado`)
};

/**
* | output |
* | --- |
* | "Closed" |
*
* @param {Reports_Status_ClosedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_status_closed = /** @type {((inputs?: Reports_Status_ClosedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Status_ClosedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_status_closed(inputs)
	return pt_br2_reports_status_closed(inputs)
});